import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { AuthService } from './auth.service';
import { UtilsServices } from '../../utils/utilsService';
import { StorageService } from '../../utils/storageService';
import { MessageService } from 'primeng/api';
import { LayoutService } from '../../layout/service/layout.service';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { LoadingService } from '../../utils/loading.service';
import { InputMaskModule } from 'primeng/inputmask';


@Component({
    selector: 'app-login',
    standalone: true,
    providers: [MessageService],
    imports: [CommonModule, NgOptimizedImage, ButtonModule, CheckboxModule, InputTextModule, InputMaskModule, PasswordModule, ToastModule, FormsModule, RouterModule, RippleModule, ReactiveFormsModule],

    template: `
        <p-toast />
        <div class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
            <div class="flex flex-col items-center justify-center">
                <div style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
                    <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20" style="border-radius: 53px">
                        <div class="flex flex--col items-center mb-4">
                            <div class="flex flex-col items-center">
                                <img *ngIf="layoutService.isDarkTheme()" ngSrc="assets/logo-white.png" alt="Logo RHapp" width="200" height="60" class="mb-8" priority />

                                <img *ngIf="!layoutService.isDarkTheme()" ngSrc="assets/logo-completa.png" alt="Logo RHapp" width="200" height="60" class="mb-8" priority />

                                <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-2">Bem Vindo ao RHapp!</div>
                                <span class="text-muted-color font-medium">Login para continuar</span>
                            </div>
                        </div>

                        <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
                            <div>
                                <label for="cpf" class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">CPF</label>

                                <p-inputMask
                                    mask="999.999.999-99"
                                    formControlName="cpf"
                                    id="cpf"
                                    placeholder="000.000.000-00"
                                    styleClass="w-full mb-8"
                                >
                                </p-inputMask>

                                <label for="senha" class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2">Senha</label>
                                <p-password id="senha" formControlName="senha" placeholder="senha" [toggleMask]="true" styleClass="mb-4" [fluid]="true" [feedback]="false"> </p-password>

                                <p-button type="submit" label="Login" styleClass="w-full" [loading]="gettingRequest"></p-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class Login implements OnInit {
    loginForm!: FormGroup;
    checked: boolean = false;
    gettingRequest: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private utilsService: UtilsServices,
        private storageService: StorageService,
        public messageService: MessageService,
        public route: Router,
        protected layoutService: LayoutService,
        private loadingService: LoadingService
    ) { }

    ngOnInit(): void {
        this.loginForm = this.formBuilder.group({
            cpf: ['', [Validators.required, Validators.minLength(14)]],
            senha: ['', Validators.required]
        });
        //this.toggleDarkMode()
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: state.darkTheme }));
    }

    login() {
        // if (!this.loginForm.valid) {
        //     return false;
        // } else {
        this.gettingRequest = true;
        this.loadingService.showFullScreenLoader('Autenticando...'); // Exibe overlay

        let cpfFormatted = this.utilsService.formatCpf(this.loginForm.controls['cpf'].value);

        this.authService.login(cpfFormatted, this.loginForm.controls['senha'].value).subscribe({
            next: () => {
                this.loadingService.updateFullScreenLoader('Login realizado! Carregando dashboard...');
                this.gettingRequest = false;

                // Pequeno delay para mostrar mensagem de sucesso
                setTimeout(() => {
                    this.loadingService.hideFullScreenLoader();

                    const permission = this.storageService.getStoragePeermission();
                    const isNr1 = permission && (permission[0] === 'nr1' || permission[0] === 'NR1');
                    const isComercial = permission && permission[0] === 'comercial';
                    const targetUrl = isNr1 ? '/dashboard/nr1' : (isComercial ? '/dashboard/convenios/dashboard' : '/dashboard');

                    this.route.navigateByUrl(targetUrl, {
                        replaceUrl: true
                    });
                }, 500);
            },
            error: (error) => {
                this.gettingRequest = false;
                this.loadingService.hideFullScreenLoader(); // Esconde overlay em caso de erro
                this.messageService.add({
                    severity: 'error',
                    summary: error?.status === 401 ? 'Falha no login' : 'Erro ao entrar',
                    detail: error?.error?.message || (
                        error?.status === 401
                            ? 'CPF ou senha inválidos.'
                            : 'Não foi possível realizar o login. Tente novamente.'
                    )
                });
            }
        });
        return true;
        // }
    }
}
